import AuthContext from "./AuthContext";
import { useContext } from "react";
import { Navigate } from "react-router-dom";

function ProtectedWrapper(props) {
  const auth = useContext(AuthContext);
  console.log("ProtectedWrapper: auth.user =", auth.user, "pathname =", window.location.pathname);
  // console.log("====================================");
  // console.log(auth);
  // console.log("====================================");

  if (!auth.user) {
    console.log("ProtectedWrapper: No auth.user, redirecting to /login");
    return <Navigate to="/login" replace />;
  }

  console.log("ProtectedWrapper: User authenticated, rendering component");
  return props.children;
}
export default ProtectedWrapper;
